<template>
  <vx-card>
    <h4 class="mb-5">Settings</h4>
    <p class="mb-5">
      These settings allow you to have maximum flexibility in your Virtual Job Experience program.
    </p>
    <p class="mb-10">
      You can turn individual settings on and off to customise it - eg: to have students complete a
      fully virtual program or to integrate pre and post work experience activities with your "Real
      World" work experience program.
    </p>
    <div v-for="(section, skey) in sections" :key="skey">
      <h5 class="mb-5">{{ section.name }}</h5>
      <ul class="vx-row mb-6">
        <li class="vx-col sm:w-1/3 w-full my-1" v-for="item in section.items" :key="item.id">
          <vs-checkbox v-model="sections_settings[item.id]">{{ item.name }}</vs-checkbox>
        </li>
      </ul>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <button
          class="btn btn-primary btn-size-medium mr-3 mb-2"
          button="submit"
          @click="saveSettings"
        >
          Save
        </button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import theApi from '@/mixins/theApi';
export default {
  data() {
    return {
      sections: {
        prework: {
          name: 'Prework Experience',
          items: [
            { name: 'Workplace Safety', id: 'workplace_safety' },
            { name: 'Workplace Preparation', id: 'workplace_preparation' },
            { name: 'Application', id: 'application' },
          ],
        },
        workexperience: {
          name: 'Work Experience',
          items: [
            { name: 'Virtual Work Experience', id: 'work_experience' },
            { name: '"Real World" Work Experience', id: 'work_experience_real' },
          ],
        },
        postwork: {
          name: 'Postwork Experience',
          items: [
            { name: 'Reflection', id: 'reflection' },
            { name: 'Thank you Letter', id: 'thankyou_letter' },
            { name: 'Certificates', id: 'certificates' },
            {
              name: 'Use school logo for "Real World" experience certificates',
              id: 'schoollogoincertificate',
            },
          ],
        },
        emailnotifications: {
          name: 'Email Notifications',
          items: [
            { name: 'Job Experience Submission', id: 'jobexperiencesubmission' },
            { name: 'Certificate Request', id: 'certificaterequest' },
          ],
        },
      },
      sections_settings: {
        workplace_safety: true,
        workplace_preparation: true,
        application: true,
        work_experience: true,
        work_experience_real: true,
        reflection: true,
        thankyou_letter: true,
        certificates: true,
        jobexperiencesubmission: false,
        certificaterequest: false,
        schoollogoincertificate: false,
      },
    };
  },
  methods: {
    saveSettings() {
      const formData = new FormData();
      for (const [key, value] of Object.entries(this.sections_settings)) {
        formData.append(key, JSON.stringify(value));
      }

      theApi.methods.makeCall(
        false,
        'vje/settings/save',
        'post',
        formData,
        'Settings saved successfully.',
        true,
      );
    },
    getSettings() {
      theApi.methods.makeCall(false, 'vje/settings/get', 'get').then(
        (data) => {
          if (data.status == 'OK' && data.settings) {
            this.sections_settings = data.settings;
          }
        },
        () => {},
      );
    },
  },
  mounted() {
    this.getSettings();
  },
};
</script>
